module.exports = __webpack_public_path__ + "assets/img/wallet.b0230472ee5c9e9d8ed0241acff4208e.svg";